import * as React from "react";

export const SettingsButtonIcon = ({
    src,
    onClick,
    "aria-label": ariaLabel
}: {
    src: any;
    onClick?: () => void;
    "aria-label"?: string;
}) => (
        <img
            role={onClick ? "button" : ""}
            tabIndex={onClick ? 0 : undefined}
            onClick={onClick}
            src={src}
            style={{ marginLeft: 16, marginRight: 16, cursor: onClick ? "pointer" : "auto" }}
            aria-label={ariaLabel}
            onKeyUp={(e) => {
                if (onClick && (e.keyCode === 13 || e.keyCode === 32)) {
                    onClick();
                }
            }}
        />
    );


// WEBPACK FOOTER //
// ./src/components/loginManagement/components/SettingsButtonIcon.tsx